enum PaymentMethodId {
    Adyen = 'adyen',
    Affirm = 'affirm',
    Afterpay = 'afterpay',
    Amazon = 'amazon',
    Braintree = 'braintree',
    BraintreeGooglePay = 'googlepaybraintree',
    BraintreeVisaCheckout = 'braintreevisacheckout',
    CCAvenueMars = 'ccavenuemars',
    ChasePay = 'chasepay',
    Converge = 'converge',
    Klarna = 'klarna',
    Masterpass = 'masterpass',
    PaypalExpress = 'paypalexpress',
    PaypalPaymentsPro = 'paypal',
    SagePay = 'sagepay',
    SquareV2 = 'squarev2',
    StripeGooglePay = 'googlepaystripe',
    StripeV3 = 'stripev3',
    Zip = 'zip',
}

export default PaymentMethodId;
